import {
  Component, Injector, Input, ViewChild
} from '@angular/core';
import {
  AbstractControl, ControlContainer, ControlValueAccessor, FormControl, FormControlDirective
} from '@angular/forms';

@Component({
  template: '',
  standalone: false
})

export abstract class BaseControlValueAccessor implements ControlValueAccessor {
  @ViewChild(FormControlDirective, { static: true })
    formControlDirective: FormControlDirective | null = null;

  @Input() formControl: FormControl | null = null;
  @Input() formControlName: string = '';

  /*
    Get hold of FormControl instance no matter whether formControl or formControlName is given.
    If formControlName is given, then this.controlContainer.control is the parent FormGroup (or FormArray) instance.
  */
  get control(): AbstractControl {
    return this.formControl || this.controlContainer?.control?.get(this.formControlName) as FormControl;
  }

  get controlContainer(): ControlContainer {
    return this.injector.get(ControlContainer);
  }

  constructor(private injector: Injector) {}

  registerOnTouched(fn: any): void {
    /*
      Todo: PE-24658 to further investigate how to get rid of the `?` in these methods
      without breaking unit tests.
    */
    this.formControlDirective?.valueAccessor?.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective?.valueAccessor?.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective?.valueAccessor?.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.formControlDirective?.valueAccessor?.setDisabledState) {
      this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
    }
  }
}
